export const removeSubscriptionPeriod = (str: string | undefined): string | undefined => {
  if (!str) return str;

  const subscriptionPattern = /\(\s*(monthly|yearly|annually)\s*\)/gi;
  const specialPattern = /IBS Special\s*-?\s*/gi;

  return str.replace(subscriptionPattern, '').replace(specialPattern, '').trim();
};
